import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/roof-cleaning-albany-ny")({
  beforeLoad: () => {
    throw redirect({ to: "/roof-washing-albany-ny", statusCode: 301 });
  },
});
